"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("../actions/internal/client");
var redux_observable_1 = require("redux-observable");
var types_1 = require("../actions/internal/types");
var operators_1 = require("rxjs/operators");
function testConnectionEpic(actions$) {
    return actions$
        .pipe(redux_observable_1.ofType(types_1.InternalClientActionType.TEST_CONNECTION), operators_1.mapTo(client_1.testConnectionComplete(true)));
}
exports.testConnectionEpic = testConnectionEpic;
//# sourceMappingURL=connectionTestEpic.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/epics/connectionTestEpic.js
 ** module id = 2072
 ** module chunks = 0
 **/